import { DateResponse } from "./AvailabilityDateResponse";

export class AvailabilityDate {
  highlight: boolean;
  dates: Date;
  customData: CustomData;

  constructor(resp: DateResponse) {
    this.highlight = true;
    this.dates = new Date(resp.departureDate);
    this.customData = new CustomData(resp);
  }
}

export class CustomData {
  class: string;
  cabins: number;
  fitsVehicle: boolean;
  hasRoom: boolean;

  constructor(resp: DateResponse) {
    this.class = getAvailabilityClass(resp);
    this.cabins = resp.cabins;
    this.fitsVehicle = resp.fitsVehicle;
    this.hasRoom = !!resp.cabins;
  }
}

const getAvailabilityClass = (resp: DateResponse) => {
  if(resp.searchedCabins){
    return resp.cabins <= 0 ? "no-cabin" : resp.cabins < 5 ? "almost-full" : "available";
  }
  return "";
};

export type AvailabilityCalendarRequest = {
  month?: number;
  year?: number;
  route?: string;
  cabin?: string;
  vehicle?: string;
};

export type monthChangeEvent = {
  date: Date;
  month: number;
  year: number;
};
